import i18n from '../../locales/index'
import restful from '@/store/vuex'

const state = {
  ...restful.states('fresh_software_version')
}

const getters = {
  ...restful.getters('fresh_software_version')
}

const actions = {
  ...restful.actions('fresh_software_versions', 'CONFIG'),
}

const mutations = {
  ...restful.mutations('fresh_software_version')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
